import React from 'react';
import { CertifiedBannerClassic } from '@fiverr-private/certified_banner';
import { APP_NAME } from '../../../../configuration/constants';
import { CertifiedBannerPropTypes } from './propTypes';
import { certifiedBannerClass } from './styles.ve.css';

const CertifiedBannerWrapper = ({ tagName, description, cta, subCategoryId, promoImageUrl, logoUrl, testId }) => (
    <CertifiedBannerClassic
        className={certifiedBannerClass}
        description={description}
        cta={cta}
        subCategoryId={subCategoryId}
        promoImageUrl={promoImageUrl}
        logoUrl={logoUrl}
        searchTerm={tagName}
        pageName={APP_NAME}
        testId={testId}
    />
);

CertifiedBannerWrapper.propTypes = CertifiedBannerPropTypes;

export { CertifiedBannerDataPropTypes } from './propTypes';

export default CertifiedBannerWrapper;
